<template>
  <div class="userDetail">
    <div class="userDetail-header blue-text">
      <div class="display-flex center-flex">
      <img src="@/assets/images/yunchucun@2x.png" alt="" class="icon">
      <div class="userDetail-label ml5">数据产业专家库</div>
      </div>
      <!-- <div class="more hand-cursor" @click="moreDetail">更多</div> -->
      <div class="fw700 display-flex center-flex">
        <GsMore @click="moreDetail">更多</GsMore>
      </div>
    </div>
    <!-- <div v-if="newsDetailData && newsDetailData.length > 0">
      <div
        class="userDetail-content"
        v-for="(item, i) in newsDetailData.slice(0, 12)"
        :key="i"
      >
        <div class="user-detail hand-cursor" @click="detailRow(item)">
          <div class="userDetail-name ellipsis-one"> {{ item.name }}</div>
          <div class="userDetail-position ellipsis-one" :title="item.enterpriseName">{{ item.enterpriseName }}</div>
          <div class="userDetail-characterIntroduction ellipsis-one" :title="item.expertProfile">{{ item.expertProfile }}</div>
        </div>
      </div>
    </div>
    <no-data v-else /> -->
    <GsSkeleton v-if="loading" :rows="6" />
    <div class="expert-cards" v-else-if="isNarrow">
      <div
        class="expert-card gs-card"
        v-for="(item, i) in displayList"
        :key="i"
        @click="detailRow(item)"
      >
        <div class="expert-name">{{ item.name }}</div>
        <div class="expert-org">{{ item.enterpriseName }}</div>
        <div class="expert-field">{{ item.expertProfile }}</div>
      </div>
    </div>
    <div v-else class="expert-table-wrap">
      <div class="expert-table-head">
        <span class="expert-cell is-name">姓名</span>
        <span class="expert-cell is-org">组织/企业</span>
        <span class="expert-cell is-field">擅长领域</span>
      </div>
      <div class="expert-table-scroll">
        <div class="expert-table-track">
          <div
            v-for="(item, i) in displayList"
            :key="'r-' + i"
            class="expert-row"
            @click="detailRow(item)"
          >
            <span class="expert-cell is-name">{{ item.name }}</span>
            <span class="expert-cell is-org">{{ item.enterpriseName }}</span>
            <span class="expert-cell is-field"><span class="ellipsis-one">{{ item.expertProfile }}</span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="click-btn" v-if="!isShowBtn">
      <el-button class="click-button hand-cursor" @click="moreDetail">
        点击更多专家
      </el-button>
    </div> -->
  </div>
</template>

<script>
import { getExpertList } from '@/api/api.js'
import NoData from '@/components/NoData/index.vue'
import { P } from '@/router/paths'
export default {
  components: { NoData },
  data() {
    return {
      prodUrl:"https://shujuzichan.com/xwzx",
      isNarrow: false,
      loading: true,
      newsDetailData: []
    };
  },
  props: {
    isShowBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /** 一页固定 10 个，超出部分在框内垂直滚动 */
    displayList() {
      return (this.newsDetailData || []).slice(0, 10)
    },
  },
  created() {
    this.syncNarrow()
    this.getExpertList()
  },
  mounted() {
    this.syncNarrow()
    window.addEventListener('resize', this.syncNarrow)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncNarrow)
  },
  methods:{
    syncNarrow() {
      this.isNarrow = typeof window !== 'undefined' && window.innerWidth < 960
    },
    detailRow(row) {
      this.$router.push(P.expertDetail(row.id)) 
    },
    getExpertList() {
      var formData = {};
      formData["pageNum"]=1
      formData["pageSize"]=10
      formData["publishStatus"]=1
      formData["handleStatus"]=1
      getExpertList(formData).then((response) => {
        this.newsDetailData = (response && response.rows) || [];
      }).finally(() => {
        this.loading = false
      });
    },
    moreDetail() {
      this.$router.push(P.experts) 
    }
  }
};
</script>

<style scoped>
.userDetail {
  background: linear-gradient( 270deg, rgba(255, 255, 255, 0.07) 0%, rgb(145,169,255, 0.1) 100%);
  border-radius: 4px;
  padding: 10px;
}
.userDetail-content {
  margin-top: 10px;
}
.userDetail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  gap: 8px;
  min-width: 0;
}
.userDetail-header > .display-flex:first-child {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.icon {
  width: 32px;
  height: 28px;
  flex: 0 0 auto;
  object-fit: contain;
}
.userDetail-label {
  font-weight: 800;
  font-family: inherit;
  font-size: 18px;
  color: #111824;
  line-height: 24px;
  height: auto;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-detail{
    padding: 5px 10px ;
    display: flex;
}
.user-detail:hover {
  background: rgba(255, 0, 0, 0.7);
}
.userDetail-name {
  width: 20%;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #0165FF;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-right: 5px;
}
.userDetail-position {
  width: 40%;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  color: #5E6166;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-right: 5px;
}
.userDetail-characterIntroduction{
    /* color: #999999; */
    width: 100%;
    /* width: 128px;
    height: 420px; */
    font-family: AlibabaPuHuiTi_3_65_Medium;
    font-size: 16px;
    color: #5E6166;
    line-height: 25px;
    text-align: left;
    font-style: normal;
}
::v-deep .el-table::before {
  height: 0;
}
::v-deep .table-style.el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px;
}
::v-deep .el-table tr, .el-table, .el-table__expanded-cell,
::v-deep .el-table th.el-table__cell {
background-color: transparent !important;
}
::v-deep .row-class {
  cursor: pointer;
}
::v-deep .row-class:hover {
  color: black !important;
  font-weight: bold;
}
::v-deep .el-table .cell {
  font-size: 16px;
}
.text-color {
  color: #0165FF;
}
::v-deep .el-table th.el-table__cell>.cell {
  font-family: AlibabaPuHuiTi_3_75_SemiBold;
  font-size: 18px;
  color: #333333;
  text-align: center;
}
.expert-cards {
  display: block;
}
/* 一页 10 行，超出用垂直滚动 */
.expert-table-wrap {
  width: 100%;
}
.expert-table-head,
.expert-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  box-sizing: border-box;
}
.expert-table-head {
  height: 40px;
  font-family: AlibabaPuHuiTi_3_75_SemiBold;
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}
.expert-table-head .expert-cell {
  color: #333333;
  font-weight: 600;
  text-align: left;
}
.expert-table-scroll {
  /* 一页 10 行：表头外 10 行 × 50px = 500px，超出才滚动 */
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  /* 不在内部做循环动画，滚到底就是底 */
  overscroll-behavior: contain;
}
.expert-table-track {
  display: block;
}
.expert-row {
  height: 50px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.expert-row:hover {
  background: rgba(1, 101, 255, 0.06);
}
.expert-cell {
  min-width: 0;
  font-family: AlibabaPuHuiTi_3_65_Medium;
  font-size: 16px;
  line-height: 25px;
  color: #5E6166;
  overflow: hidden;
}
.expert-cell.is-name {
  flex: 0 0 24%;
  color: #0165FF;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.expert-cell.is-org {
  flex: 0 0 36%;
  text-align: left;
}
.expert-cell.is-field {
  flex: 1 1 auto;
  text-align: left;
}
.expert-cell.is-field .ellipsis-one {
  display: block;
}
@media (max-width: 960px) {
  .userDetail-label {
    font-size: 15px;
    line-height: 22px;
  }
  .expert-table-wrap {
    display: none !important;
  }
  .expert-cards {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .expert-card {
    background: #fff;
    border-radius: 10px;
    padding: 8px 10px;
    margin-bottom: 0;
    overflow: hidden;
  }
  .expert-name {
    color: #0165FF;
    font-weight: 700;
    font-size: 13px;
  }
  .expert-org {
    color: #5E6166;
    font-size: 11px;
    margin: 3px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .expert-field {
    color: #666;
    font-size: 11px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>